'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EXTERNAL_API_EVENT = exports.EXTERNAL_API_EVENT = 'external-api-event';


//////////////////
// WEBPACK FOOTER
// ./js/external-api-events/constants/externalApiEventsPostMessageTypes.js
// module id = 818
// module chunks = 2 3